import { Reveal } from "./Reveal";
import { Repeat, ShieldCheck, Sparkles, LineChart } from "lucide-react";

const SERVICES = [
  {
    n: "01",
    icon: Repeat,
    title: "The 5-Star Feedback Loop",
    body: "Smart, automated infrastructure captures feedback consistently. Great experience? We make leaving a glowing Google review effortless. Neutral? We deploy our signature hospitality tactic — reaching out to learn exactly how to earn five stars next time.",
  },
  {
    n: "02",
    icon: ShieldCheck,
    title: "Public & Private Review Management",
    body: "Negative reviews happen — they don't have to define you. We handle public damage control with total accountability, showing future customers you're a respectful, attentive operator, while initiating private resolutions to make things right.",
  },
  {
    n: "03",
    icon: Sparkles,
    title: "Reputation Reactivation",
    body: "Spending thousands on ads but losing leads to a 2.5-star profile? We revitalize \"ghost town\" profiles by respectfully reaching out to past customers, generating a fresh wave of positive reviews that signal you're open, active, and trusted.",
  },
  {
    n: "04",
    icon: LineChart,
    title: "Digital Infrastructure & Reporting",
    body: "You don't have time to sit at a computer all day. We use top-tier automation to monitor your reputation around the clock and deliver clear, regular data — so you see exactly how reputation translates into revenue.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-grid" className="bg-background py-24 lg:py-32">
      <div className="container-luxe">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <Reveal>
            <p className="overline">Services 01 — 04</p>
            <h2 className="mt-4 serif text-[clamp(1.9rem,3.8vw,3.4rem)] leading-tight tracking-tight text-foreground">
              Hospitality-grade <span className="italic text-gold">reputation management.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
              We work smarter, not harder — from fully automated review engines to
              highly personalized, done-for-you concierge management.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-px bg-border border border-border">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.n} delay={i * 0.08}>
                <div
                  data-testid={`service-card-${s.n}`}
                  className="group relative h-full bg-background p-9 lg:p-12 transition-[background-color,transform] duration-500 hover:bg-[var(--blush)]/60 hover:-translate-y-1"
                >
                  <div className="flex items-start justify-between">
                    <span className="serif text-3xl text-[var(--gold)]">{s.n}</span>
                    <Icon
                      size={26}
                      className="text-muted-foreground transition-colors duration-400 group-hover:text-[var(--gold)]"
                      strokeWidth={1.4}
                    />
                  </div>
                  <h3 className="mt-8 serif text-2xl text-foreground">{s.title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                    {s.body}
                  </p>
                  <span className="pointer-events-none absolute bottom-0 left-0 h-[2px] w-0 bg-[var(--gold)] transition-all duration-500 group-hover:w-full" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
